module.exports = __webpack_public_path__ + "static/media/img_03.ab547828.png";